<template>
    <section>
        <div class="container">
            <h2 class="pb-2">{{ titulo != null ? titulo : this.title != null ? this.title : '' }}</h2>


            <div v-if="!items" class="row row-cols-1 g-4"
                v-bind:class="[columnas > 0 ? 'row-cols-md-' + columnas : 'row-cols-md-3']">
                <div class="col" v-for="n in (parseInt(columnas) > 0 ? parseInt(columnas) : 3)" v-bind:key="n">
                    <div class="card loading-card-second {{n}}">
                        <div class="card-body rounded d-flex align-items-center">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row row-cols-1 g-4 text-center"
                v-bind:class="[columnas > 0 ? 'row-cols-md-' + columnas : 'row-cols-md-3']">
                <div class="col" v-for="(el, i) in items" :key="i">
                    <div class="card text-bg-ptn-color-gsj-brand card-hover" :class="{ 'has-dropdown': el.dropdown }">
                        <div class="card-body" style="position: relative;">
                            <h3 class="my-0 " style="font-size: 1.1rem !important;">
                                <!-- Elemento con menú desplegable -->
                                <span v-if="el.dropdown" class="dropdown-trigger text-reset"
                                    @click.prevent="toggleDropdown(i)"
                                    style="position:relative;display:inline-block;cursor:pointer;">
                                    {{ el.title }}
                                    <i class="fas fa-chevron-down ms-2"></i>
                                    <!-- Desktop: menú inline -->
                                    <div v-if="activeDropdown === i && !isModalOpen() && isDesktop()"
                                        class="styled-dropdown-menu" @click.stop>
                                        <div v-for="(item, idx) in el.dropdown" :key="item.title"
                                            class="styled-dropdown-item-wrapper"
                                            :class="{ 'no-border': idx === el.dropdown.length - 1 }">
                                            <a v-if="!item.modal" :href="item.url" :target="item.target || '_blank'"
                                                class="styled-dropdown-item" @click.stop="activeDropdown = null">
                                                <span class="dropdown-item-title">{{ item.title }}</span>
                                            </a>
                                            <button v-else
                                                @click.stop.prevent="openModal(item.modal); activeDropdown = null"
                                                class="styled-dropdown-item styled-dropdown-item-btn">
                                                <span class="dropdown-item-title">{{ item.title }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </span>
                                <!-- Elemento normal -->
                                <a v-else v-bind:href="el.url" v-bind:target="el.target ? el.target : '_self'"
                                    class="stretched-link text-reset">{{ el.title }}</a>
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mobile: menú usando teleport para evitar interferencias -->
        <teleport to="body">
            <div v-if="activeDropdown !== null && !isModalOpen() && !isDesktop()" class="mobile-dropdown-overlay"
                @click.self="activeDropdown = null">
                <div class="mobile-dropdown-menu">
                    <div class="mobile-dropdown-header">
                        <span>{{ items[activeDropdown]?.title }}</span>
                        <button @click="activeDropdown = null" class="mobile-close-btn">&times;</button>
                    </div>
                    <div v-for="(item, idx) in items[activeDropdown]?.dropdown" :key="item.title"
                        class="mobile-dropdown-item-wrapper"
                        :class="{ 'no-border': idx === items[activeDropdown]?.dropdown.length - 1 }">
                        <a v-if="!item.modal" :href="item.url" :target="item.target || '_blank'"
                            class="mobile-dropdown-item" @click="activeDropdown = null">
                            <span class="dropdown-item-title">{{ item.title }}</span>
                        </a>
                        <button v-else @click.stop.prevent="openModal(item.modal); activeDropdown = null"
                            class="mobile-dropdown-item mobile-dropdown-item-btn">
                            <span class="dropdown-item-title">{{ item.title }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </teleport>

        <!-- Modal de Geoservicios -->
        <GeoservicesModal />
    </section>
</template>

<script>
import GeoservicesModal from './GeoservicesModal.vue';

const axios = require('axios');
export default {
    name: "CardGridComponent",
    components: {
        GeoservicesModal
    },
    props: {
        titulo: String,
        subtitulo: String,
        columnas: String,
        filtros: Object,
        data: Object
    },
    data() {
        return {
            hash: "CGC",
            items: null,
            title: null,
            desc: null,
            activeDropdown: null
        }
    },
    methods: {
        isDesktop() {
            return window.innerWidth > 768;
        },
        // Hover handlers removed: dropdown opens only on click now
        toggleDropdown(index) {
            if (!this.isModalOpen()) {
                this.activeDropdown = this.activeDropdown === index ? null : index;
            }
        },
        isModalOpen() {
            return document.body.classList.contains('modal-open');
        },
        openModal(modalId) {
            this.activeDropdown = null; // Cerrar menú al abrir modal

            // Pequeño delay para asegurar que el click se procese correctamente
            setTimeout(() => {
                if (modalId === 'geoservices') {
                    const modalElement = document.getElementById('geoservicesModal');
                    if (modalElement) {
                        // Mostrar modal
                        modalElement.classList.add('show');
                        modalElement.style.display = 'block';
                        modalElement.setAttribute('aria-hidden', 'false');

                        // Agregar backdrop si no existe
                        let existingBackdrop = document.getElementById('modal-backdrop-geoservices');
                        if (!existingBackdrop) {
                            const backdrop = document.createElement('div');
                            backdrop.className = 'modal-backdrop fade show';
                            backdrop.id = 'modal-backdrop-geoservices';
                            document.body.appendChild(backdrop);
                            existingBackdrop = backdrop;
                        }
                        document.body.classList.add('modal-open');

                        // Cleanup function that always removes backdrop and modal-open class
                        const cleanup = () => {
                            try {
                                if (modalElement) {
                                    modalElement.classList.remove('show');
                                    modalElement.style.display = 'none';
                                    modalElement.setAttribute('aria-hidden', 'true');
                                }
                                const eb = document.getElementById('modal-backdrop-geoservices');
                                if (eb) eb.remove();
                                document.body.classList.remove('modal-open');
                            } catch (err) {
                                // ignore
                            }
                        };

                        // Attach cleanup to all dismiss buttons inside modal
                        const dismissButtons = modalElement.querySelectorAll('[data-bs-dismiss="modal"]');
                        dismissButtons.forEach(btn => {
                            btn.addEventListener('click', cleanup);
                        });

                        // If backdrop element exists, close when clicked
                        if (existingBackdrop) {
                            existingBackdrop.addEventListener('click', cleanup);
                        }

                        // Observe modal element for class/style changes to handle outside closes
                        const observer = new MutationObserver((mutations) => {
                            for (const m of mutations) {
                                if (m.attributeName === 'class' || m.attributeName === 'style') {
                                    if (!modalElement.classList.contains('show') || modalElement.style.display === 'none') {
                                        cleanup();
                                        observer.disconnect();
                                    }
                                }
                            }
                        });
                        observer.observe(modalElement, { attributes: true, attributeFilter: ['class', 'style'] });

                        // ESC key
                        const escHandler = (e) => {
                            if (e.key === 'Escape') {
                                cleanup();
                                document.removeEventListener('keydown', escHandler);
                                observer.disconnect();
                            }
                        };
                        document.addEventListener('keydown', escHandler);
                    }
                }
            }, 50);
        }
    },
    mounted() {
        if (this.data == null) {
            let params = {};
            if (this.filtros != null && this.filtros != "") {
                params = this.filtros;
            }
            params.tipo = this.hash;
            axios.post(process.env.VUE_APP_API_URL, params)
                .then(response => {
                    this.items = response.data ? response.data.items : null
                    this.title = response.data ? response.data.title : null
                    this.desc = response.data ? response.data.desc : null
                    localStorage.setItem(this.hash, JSON.stringify(response));
                })
                .catch(error => {
                    if (!error.response) {
                        console.log("Fuera de Linea");
                        if (localStorage.getItem(this.hash)) {
                            console.log("Cargando elementos de cache para " + this.hash);
                            var resp = JSON.parse(localStorage.getItem(this.hash));
                            this.items = resp.data ? resp.data.items : null
                            this.title = resp.data ? resp.data.title : null
                            this.desc = resp.data ? resp.data.desc : null
                        }
                    }
                })
        } else {
            this.items = this.data;
        }
    }
}
</script>

<style scoped>
.card-hover {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card-hover:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.dropdown-trigger:hover {
    color: inherit !important;
}

.has-dropdown .stretched-link {
    position: static !important;
}

.has-dropdown {
    overflow: visible !important;
}

/* Desktop dropdown styles */
.styled-dropdown-menu {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    min-width: 280px;
    margin-top: 8px;
    overflow: hidden;
    animation: fadeInDown 0.2s ease-out;
}

@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateX(-50%) translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
}

.styled-dropdown-item-wrapper {
    border-bottom: 1px solid #f0f0f0;
}

.styled-dropdown-item-wrapper.no-border {
    border-bottom: none;
}

.styled-dropdown-item {
    display: block;
    padding: 12px 16px;
    color: #333;
    text-decoration: none;
    background: white;
    border: none;
    width: 100%;
    text-align: left;
    transition: background-color 0.2s ease;
    font-size: 14px;
    line-height: 1.4;
}

.styled-dropdown-item:hover {
    background-color: #f8f9fa;
    color: #0066cc;
    text-decoration: none;
}

.styled-dropdown-item-btn {
    cursor: pointer;
}

.dropdown-item-title {
    font-weight: 500;
}

/* Mobile dropdown styles */
.mobile-dropdown-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.mobile-dropdown-menu {
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 400px;
    max-height: 80vh;
    overflow: hidden;
    animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.mobile-dropdown-header {
    background: #f8f9fa;
    padding: 16px 20px;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    color: #333;
}

.mobile-close-btn {
    background: none;
    border: none;
    font-size: 24px;
    color: #666;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mobile-close-btn:hover {
    color: #333;
}

.mobile-dropdown-item-wrapper {
    border-bottom: 1px solid #f0f0f0;
}

.mobile-dropdown-item-wrapper.no-border {
    border-bottom: none;
}

.mobile-dropdown-item {
    display: block;
    padding: 16px 20px;
    color: #333;
    text-decoration: none;
    background: white;
    border: none;
    width: 100%;
    text-align: left;
    transition: background-color 0.2s ease;
    font-size: 16px;
    line-height: 1.4;
}

.mobile-dropdown-item:hover,
.mobile-dropdown-item:active {
    background-color: #f8f9fa;
    color: #0066cc;
    text-decoration: none;
}

.mobile-dropdown-item-btn {
    cursor: pointer;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .mobile-dropdown-menu {
        margin: 10px;
        max-width: calc(100vw - 20px);
    }
}
</style>